import InsiderMessengerUpsellPage from "@faire/prototype-playground/workspace/jli/insider-messenger-upsell";
import { Route, Switch } from "react-router-dom";

export function JustinLiRoutes() {
  return (
    <Switch>
      <Route
        path="/jli/insider-messenger-upsell"
        component={InsiderMessengerUpsellPage}
      />
    </Switch>
  );
}

export const slug = "jli";
